import React from "react";
import PropTypes from "prop-types";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import IndeterminateCheckBox from "@mui/icons-material/IndeterminateCheckBox";

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, fields, collapsible } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead
      className={classes.tableHead}
      style={
        props.stickyTable
          ? { position: "sticky", top: 0, zIndex: 1 }
          : undefined
      }
    >
      <TableRow>
        {collapsible && <TableCell colSpan={1} />}
        {props.showSelectAll ? (
          <TableCell padding="checkbox">
            <Checkbox
              style={props.showCheckbox}
              color="primary"
              onClick={() => {
                if (typeof props.onSelectAll === "function") {
                  if ((props.selectedRecords?.length || 0) > 0) {
                    props.onSelectAll(false);
                  } else {
                    props.onSelectAll(true);
                  }
                }
              }}
              checked={
                (props.selectedRecords?.length || 0) > 0 &&
                props.selectedRecords?.length === props.data?.length
              }
              indeterminate={
                (props.selectedRecords?.length || 0) > 0 &&
                props.selectedRecords?.length < (props.data?.length || 0)
              }
              indeterminateIcon={<IndeterminateCheckBox color="primary" />}
            />
          </TableCell>
        ) : (
          <TableCell colSpan={1} />
        )}
        {fields
          .filter((x) => x.visible)
          .map((headCell, __i) => (
            <TableCell
              key={`${headCell.key || headCell.label || "col"}-${__i}`}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.key ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.key}
                direction={orderBy === headCell.key ? order : "asc"}
                disabled={headCell?.disableSorting}
                onClick={createSortHandler(headCell.key)}
                className={classes.headCell}
              >
                {headCell.columnName}
                {orderBy === headCell.key ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  fields: PropTypes.array.isRequired,
};

export default EnhancedTableHead;
